class UnexpectedError extends Error {
  constructor() {
    super('Unexpected error has happened!');
    this.name = this.constructor.name;
  }
}

export default UnexpectedError;
